import React from 'react';
import DemoStage from '../DemoStage.jsx';

/**
 * Animated walkthrough of adding a cost line: one existing line and its total,
 * Add cost is clicked, a new Refund line lands and the per-currency total
 * updates. Category pills use the real .cost-pill classes from CostChip.jsx /
 * global.css. Placeholder data only — and deliberately one currency, since the
 * app never converts between them.
 */

const STEPS = [
  {
    caption: 'A cost line: date incurred, category pill, amount in its own currency.',
    scene: 'one', ms: 2600,
    cursor: 'add',
  },
  {
    caption: 'Add cost — amount, currency, category and the date it was incurred.',
    scene: 'one', ms: 1400,
    cursor: 'add', click: true,
  },
  {
    caption: 'The new line lands on the case…',
    scene: 'two', ms: 2200,
  },
  {
    caption: '…and the total updates. Totals are kept per currency — euro and sterling never merge.',
    scene: 'two', ms: 3200,
  },
];

const cell = { padding: '8px 8px', borderBottom: '1px solid var(--border)', fontSize: 12.5 };
const headCell = {
  ...cell,
  color: 'var(--text-3)', fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.04em',
};

export default function CostLineDemo() {
  return (
    <DemoStage steps={STEPS} label="Adding a cost line" height={210}>
      {(step) => {
        const scene = step?.scene ?? 'one';
        const two = scene === 'two';
        return (
          <div className="kb-mock">
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--text)' }}>Costs</span>
                <span style={{ fontSize: 12.5, color: 'var(--text-2)' }}>
                  Total: <strong style={{ color: 'var(--text)' }}>{two ? '€230.00' : '€80.00'}</strong>
                </span>
              </div>
              <button type="button" className="btn primary sm" tabIndex={-1} data-kb-target="add">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" style={{ width: 12, height: 12 }}>
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Add cost
              </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left' }}>
                  <th style={headCell}>Date</th>
                  <th style={headCell}>Category</th>
                  <th style={{ ...headCell, textAlign: 'right' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ ...cell, whiteSpace: 'nowrap' }}>05 Jun 2026</td>
                  <td style={cell}><span className="cost-pill cost-goodwill">Goodwill</span></td>
                  <td style={{ ...cell, textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>€80.00</td>
                </tr>
                {two && (
                  <tr className="kb-pop">
                    <td style={{ ...cell, whiteSpace: 'nowrap' }}>28 Jun 2026</td>
                    <td style={cell}><span className="cost-pill cost-refund">Refund</span></td>
                    <td style={{ ...cell, textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>€150.00</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      }}
    </DemoStage>
  );
}
